import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { CardBody, UncontrolledTooltip } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RelevoAdministrativoModal from "../../../components/RelevosInfoGeneral/RelevoAdministrativoModal";
import { OptionsButton, DownloadFileButton } from "../../../components/RelevosInfoGeneral/styles";
import { fetchPiAsignable } from "../../../services/ticketingServices";
import useFetcher from "../../../hooks/useFetcher";
import usePaging from "../../../hooks/usePaging";
import { getRelevosAdministrativos } from "../../../services/relevoAdministrativoServices";
import { getFileIconName } from "../../FileManager/fileItem";
import { getPiById, handleClickFile, handleClickGeneratePdf } from "../../../components/RelevosInfoGeneral/utils";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { ButtonPrimary } from "../../../ui/buttons";

export default function RelevoAdministrativo({ history, clientId, isAudit }) {
  const [pis, isLoadingPis] = useFetcher(fetchPiAsignable);
  const pagingController = usePaging(getRelevosAdministrativos);
  const [upload, setUpload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [infoRow, setInfoRow] = useState(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState("");

  useEffect(() => {
    pagingController.setFilterValue({ clientId });
  });

  const reloadRelevos = () => {
    pagingController.reloadData(history.location);
  };

  const handleRowClicked = (row) => {
    if (isAudit) return;
    setInfoRow(row);
    setShowForm(true);
    if (row.template === false) {
      setUpload(true);
    } else {
      setUpload(false);
    }
  };

  const handleDownloadFile = async (row) => {
    setIsLoadingFiles(row.id);
    if (row.template !== false) {
      const res = await handleClickGeneratePdf(row, reloadRelevos);
      await handleClickFile(row.Files[0], res.id);
    } else {
      await handleClickFile(row.Files[0]);
    }

    setIsLoadingFiles("");
  };

  const handleGeneratePdf = async (row) => {
    setIsLoadingFiles(row.id);
    await handleClickGeneratePdf(row, reloadRelevos);
    setIsLoadingFiles("");
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <RelevoAdministrativoModal
        toggle={() => {
          setShowForm(!showForm);
          setInfoRow(null);
        }}
        isOpen={showForm}
        upload={upload}
        clientId={clientId}
        reloadRelevos={reloadRelevos}
        infoRow={infoRow}
      />
      <CardBody className="pb-3 d-flex flex-column" style={{ overflow: "auto", minHeight: "200px" }}>
        <div className="form-group align-self-end">
          {!isAudit && (
            <Dropdown style={{ display: "flex", alignItems: "center" }}>
              <Dropdown.Toggle
                align="start"
                className="btn"
                id="dropdown-basic"
                style={{ display: "flex", alignItems: "center", fontFamily: "Nunito" }}
                as={ButtonPrimary}
              >
                Nuevo relevo administrativo
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  width: "17rem",
                  alignItems: "center",
                  boxShadow: " -3px 6px 21px 2px rgba(0,0,0,0.8)",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontFamily: "Nunito" }}>
                  <OptionsButton
                    className="btn mb-2 hover:bg-success hover:text-white"
                    style={{ height: "40px", width: "220px", margin: "auto" }}
                    type="submit"
                    onClick={() => {
                      setShowForm(!showForm);
                      setUpload(false);
                    }}
                  >
                    Crear template
                  </OptionsButton>
                  <OptionsButton
                    className="btn"
                    style={{ height: "40px", width: "220px", fontFamily: "Nunito" }}
                    type="submit"
                    onClick={() => {
                      setShowForm(!showForm);
                      setUpload(true);
                    }}
                  >
                    Subir archivo
                  </OptionsButton>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
        <BlurSpinner isLoading={isLoadingPis}>
          <DataTable
            data={pagingController.data}
            style={{ fontFamily: "Nunito !important" }}
            onRowClicked={(row) => handleRowClicked(row)}
            noDataComponent={
              <div className="p-3">
                <b>No se cargaron Relevos Administrativos</b>
              </div>
            }
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10]}
            paginationComponentOptions={{ rowsPerPageText: "Candidatos por página", rangeSeparatorText: "de" }}
            striped
            columns={[
              {
                name: "Título",
                selector: (row) => row.titulo && row.titulo,
                center: true,
                compact: true,
                sortable: true,
                style: {
                  textAlign: "center",
                  cursor: "pointer",
                },
              },
              {
                name: "Última actualización",
                selector: (row) => row.updatedAt && row.actualizadoPor && `${moment(row.updatedAt).format("DD/MM/YYYY")} (${getPiById(row.actualizadoPor, pis)})`,
                center: true,
                compact: true,
                style: {
                  textAlign: "center",
                  cursor: "pointer",
                },
              },
              {
                name: "Subcliente",
                selector: (row) =>
                  row.relsRelevoAdministrativoSubcliente && row.relsRelevoAdministrativoSubcliente.length === 1
                    ? row.relsRelevoAdministrativoSubcliente[0].numeroDeLegajo.replace(/\.\d+/, "")
                    : `${row.relsRelevoAdministrativoSubcliente[0].numeroDeLegajo.replace(/\.\d+/, "")}(...)`,
                center: true,
                compact: true,
                // width: "100px",
                style: {
                  textAlign: "center",
                  cursor: "pointer",
                },
              },
              {
                name: "Cargo",
                selector: (row) => row.cargo && row.cargo,
                center: true,
                compact: true,
                style: {
                  textAlign: "center",
                  cursor: "pointer",
                },
              },
              {
                name: "Archivo",
                selector: (row) =>
                  row.Files.length > 0 ? (
                    <>
                      <UncontrolledTooltip target={`downloadFile${row.id}`}>Descargar archivo</UncontrolledTooltip>
                      <DownloadFileButton
                        id={`downloadFile${row.id}`}
                        aria-label="download file"
                        type="button"
                        style={{ border: "none", background: "none", cursor: "pointer" }}
                        onClick={() => handleDownloadFile(row)}
                      >
                        <BlurSpinner isLoading={isLoadingFiles === row.id}>
                          <FontAwesomeIcon color="#293134" size="lg" icon={getFileIconName(row.Files[0].mimetype)} />
                        </BlurSpinner>
                      </DownloadFileButton>
                    </>
                  ) : (
                    <>
                      <UncontrolledTooltip target={`generatePdfFile${row.id}`}>Generar pdf</UncontrolledTooltip>
                      <DownloadFileButton
                        id={`generatePdfFile${row.id}`}
                        aria-label="generate file"
                        type="button"
                        style={{ border: "none", background: "none", cursor: "pointer" }}
                        onClick={() => handleGeneratePdf(row)}
                        // disabled={isAudit}
                      >
                        <BlurSpinner isLoading={isLoadingFiles === row.id}>
                          <FontAwesomeIcon color="#CCCCCC" size="lg" icon={getFileIconName("pdf")} />
                        </BlurSpinner>
                      </DownloadFileButton>
                    </>
                  ),
                // width: "80px",
                center: true,
                compact: true,
                style: {
                  textAlign: "center",
                  cursor: "pointer",
                },
              },
            ]}
          />
        </BlurSpinner>
      </CardBody>
    </div>
  );
}
